/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'manageCheckImplementationViewSetting', params:{ bottunid:bottunid }} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">チェック実施ページ編集画面</p>
                </div>
            </div>
        </div>
        <CheckImplementationViewSettingPage/>
    </div>

</template>

<script>
    import CheckImplementationViewSettingPage from '@/app/components/CheckImplementationViewSettingPage.vue'
    export default {
        name: 'manageCheckViewSettingPage',
        components: {
          CheckImplementationViewSettingPage
        },
        computed: {
            bottunid: function () {
                return this.$store.getters['checkPage/buttonId']
            },
        },
    }
</script>
